/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Status of a thumbnail image in the prefetch pipeline.
 */
export enum ThumbnailStatus {
  PENDING = 0,
  LOADING = 1,
  LOADED = 2,
  FAILED = 3
}
